/**
 * Публичный лендинг: CSS-фоны и опциональные иллюстрации из platform-assets.
 * JPG hero/секции — операторские (volume); в git — SVG + CSS-градиенты (без 404 на clone).
 */

export const LANDING_ASSETS_API = '/api/platform-assets/landing';

export const lpFile = (name) => `${LANDING_ASSETS_API}/${name}`;

/** Тёмный кадр той же сцены: `b09_catalog_upload.jpg` → `b09_catalog_upload_dark.jpg`. */
export const lpDarkFile = (name) =>
  lpFile(String(name || '').replace(/(\.[a-z0-9]+)$/i, '_dark$1'));

/** Градиенты для полноэкранных фонов; eb-* SVG — только для кирпичей/крыш. JPG b01/b02 — опционально через LandingOptionalImage. */
export const LANDING_PAGE_CSS_VARS = {
  '--lp-b01': [
    'radial-gradient(ellipse 80% 72% at 82% 38%, rgba(42,191,191,0.16) 0%, transparent 58%)',
    'radial-gradient(ellipse 58% 52% at 18% 40%, rgba(218,165,32,0.10) 0%, transparent 54%)',
    'linear-gradient(118deg, #F5F0E8 0%, #efe6d6 46%, #e4d5b8 100%)',
  ].join(', '),
  '--lp-b02': [
    'radial-gradient(ellipse 90% 62% at 50% 100%, rgba(42,191,191,0.16) 0%, transparent 58%)',
    'radial-gradient(ellipse 68% 48% at 50% 22%, rgba(218,165,32,0.10) 0%, transparent 52%)',
    'linear-gradient(168deg, #1a120c 0%, #2a1d12 42%, #1c1410 100%)',
  ].join(', '),
  '--lp-capabilities-bg': [
    'linear-gradient(135deg, rgba(42,191,191,0.18) 0%, rgba(26,26,26,0.04) 55%, rgba(245,240,232,0.95) 100%)',
    `url(${lpFile('eb-foundation-trade.svg')})`,
  ].join(', '),
  '--lp-eb-foundation-core': `url(${lpFile('eb-foundation-core.svg')})`,
  '--lp-eb-foundation-ops': `url(${lpFile('eb-foundation-ops.svg')})`,
  '--lp-eb-foundation-mgmt': `url(${lpFile('eb-foundation-mgmt.svg')})`,
  '--lp-eb-foundation-trade': `url(${lpFile('eb-foundation-trade.svg')})`,
  '--lp-eb-roof-core': `url(${lpFile('eb-roof-izba-core.svg')})`,
  '--lp-eb-roof-ops': `url(${lpFile('eb-roof-izba-ops.svg')})`,
  '--lp-eb-roof-mgmt': `url(${lpFile('eb-roof-izba-mgmt.svg')})`,
  '--lp-eb-roof-trade': `url(${lpFile('eb-roof-izba-trade.svg')})`,
};
